var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 120 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 h 100 v 100 h -25 l -25,25 l -25,-25 h -25 Z",
    id: "foreground",
    style: {
      fill: "#fff",
      stroke: "#45a",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("svg", _extends({
    x: 25,
    y: 25,
    width: 70,
    height: 70,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2432 12.1796C15.9356 12.5173 16.8775 12.0106 17.347 11.0479C17.8166 10.0852 17.636 9.03097 16.9436 8.69328C16.2512 8.35558 15.3093 8.86227 14.8397 9.825C14.3702 10.7877 14.5508 11.8419 15.2432 12.1796Z",
    fill: "#973"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.95521 4.09553C4.46555 0.998872 7.45153 -0.673365 9.72376 0.256273L9.75288 0.197981L12.0971 0.968436C10.0224 1.6813 8.00376 3.51372 6.74991 6.08448C5.67575 8.28683 5.37418 10.5979 5.75973 12.5189L6.6131 12.9692C6.56724 12.56 6.54358 12.1427 6.54358 11.7189C6.54358 9.07062 7.46745 6.67386 8.96002 4.94258C10.7872 2.47301 13.5146 1.29795 15.6558 2.21718C15.8172 2.23795 15.9771 2.26417 16.1356 2.2957L17.7918 2.84002C17.857 2.87044 17.9218 2.90181 17.9862 2.93412L17.963 2.89629L18.0218 2.91562L17.9964 2.98377C18.1331 3.03234 18.2677 3.08879 18.4 3.1533C21.0462 4.44395 21.7366 8.47303 19.942 12.1525C18.8989 14.2912 17.2458 15.841 15.5247 16.5106L15.5505 16.5218L11.8869 18.5167C11.0693 18.9618 10.0721 18.9159 9.29894 18.3974L0.110981 12.2356C-0.0799194 12.1076 -0.0114214 11.8114 0.216309 11.7803L3.47272 11.3343C1.87779 9.85928 1.60531 6.86323 2.95521 4.09553ZM13.5593 14.8883C15.3583 15.6272 17.7243 14.3029 18.9209 11.8496C20.1525 9.32446 19.6787 6.55937 17.8627 5.67363C17.266 5.38262 16.5987 5.33068 15.9279 5.48168C14.5948 5.82737 13.263 6.966 12.459 8.61429C11.2274 11.1395 11.7012 13.9045 13.5173 14.7903C13.5394 14.8011 13.5617 14.8116 13.5841 14.8217L13.5593 14.8883Z",
    fill: "#973"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedNormal);
export default __webpack_public_path__ + "static/media/FeedNormal.bed0bd37703ddd606dc299f7b3de5bdf.svg";
export { ForwardRef as ReactComponent };